import OldProjectDashboardStore from "./JobDashboard/ProjectDashboardStore";
import ProjectDashboardStore from "./ProjectDashboard/ProjectDashboard.Store";
import JobScheduleViewStore from "./ProjectDashboard/JobScheduleView.Store";
import JobGanttChartStore from "./JobGanttChart/JobGanttChartStore";

const projectManagementStoreList = [
    { name: "oldProjectDashboardStore", store: OldProjectDashboardStore },
    { name: "projectDashboardStore", store: ProjectDashboardStore },
    { name: "jobScheduleViewStore", store: JobScheduleViewStore },
    { name: "jobGanttChartStore", store: JobGanttChartStore },
];

// Removed: JobPanelCountsStore - Precast-specific panel tracking not needed for ReadyMix

export default projectManagementStoreList;
